<div class="modal-video bottom-sheet-directive">
  <div #videoPlayer class="video-player border-radius-5">
    <!-- Error message display -->
    <div *ngIf="errorMessage" class="text-size-16 loading text-color-secondary-2">
      <div *ngIf="!fatalError" class="loader">
        <div *ngFor="let i of [1,2,3,4,5]" class="l_ball" id="l_ball_{{i}}">
          <div class="inner_ball"></div>
        </div>
      </div>
      <div class="message">
        <svg style="width: 15px; height:15px;">
          <circle cx="8" cy="10" r="4" [attr.fill]="color" />
        </svg>
        {{errorMessage}}
      </div>
    </div>
    <!-- Video player -->
    <video id="videoPlayerStreaming" controls controlsList="nodownload noplaybackrate" class="full-width" muted autoplay
      error>
      <div style="color: white;">
        Tu navegador no soporta la reproducción de video.
      </div>
    </video>
  </div>
</div>
